import React, { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { useLocales } from '@/locales';
import { InlineError } from '@/errors/ErrorViews';
import ClientCredentials from '@/pages/auth/components/ClientAuth/ClientCredentials';
import { useClientAuth } from '@/pages/auth/hooks/useClientAuth';

const ClientLoginForm = () => {
  const { translate } = useLocales();

  const {
    credentials,
    errors,
    isLoading,
    error,
    canSubmit,
    rateLimitInfo,
    handleCredentialChange,
    handleSubmit,
    resetForm,
  } = useClientAuth();

  useEffect(() => {
    return () => {
      resetForm();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && (
        <InlineError message={error.message} requestId={error.requestId} />
      )}

      <ClientCredentials
        credentials={credentials}
        errors={errors}
        onChange={handleCredentialChange}
      />

      <Button className="w-full" type="submit" disabled={!canSubmit}>
        {translate('Login') || 'Login'}
        {isLoading && <Spinner size={16} className="ml-2" />}
      </Button>

      {!rateLimitInfo.allowed && (
        <p className="text-sm text-center text-amber-600">
          {translate('Please wait')}{' '}
          {Math.ceil(rateLimitInfo.remainingTime / 1000)}s
        </p>
      )}
    </form>
  );
};

export default ClientLoginForm;
